export default "data:text/plain;base64,djEuNS4yMDYK"